import * as React from 'react';
import theme from '../utils/theme';
import { SectionHeader } from './SectionHeader';

export interface Section {
  title: string;
  children: any;
  bodyStyle?: string;
  id?: string;
  className?: string;
}

export const Section = (props: Section) => (
  <div className={theme.section.wrapper} id={props.id}>
    <SectionHeader title={props.title} />
    <div className={theme.section.panel}>
      {props.children}
    </div>
  </div>
);

export default Section;
